/**
 * List of states for a capital commitment
 */
export enum CommitmentState {
    Requested = 'Requested',
    Submitted = 'Submitted',
    Approved = 'Approved',
    Rejected = 'Rejected'
}